<template>
  <div>
    <logo-search></logo-search>
    <div class="mainswiper">
      <left-nav title="中学" categoryCode="414"></left-nav>
      <div class="mid-part">
        <main-nav :data="middleMainNav"></main-nav>
        <div class="content">
          <div class="admodel"><ad-model adCode="871"></ad-model></div>
          <hot-article></hot-article>
          <div class="right-part">
            <login-table></login-table>
            <news title_1="优惠活动" title_2="优能动态" adCode="874" :newsData="newsData"></news>
          </div>
        </div>
      </div>
    </div>
    <div style="margin: 18px 0;"><ad-model adCode="1178"></ad-model></div>
  </div>
</template>

<script>
import { middleMainNav } from 'js/middleschool/mainnav.js'
import { getArticle } from 'js/getArticle.js'
import { cityFormInfo } from 'js/staticData.js'
import LogoSearch from './components/Logosearch'
import LeftNav from './components/Leftnav'
import MainNav from '@/common-components/Mainnav'
import AdModel from '@/common-components/AdModel'
import News from '@/common-components/News'
import LoginTable from './components/Logintable'
import HotArticle from './components/Hotarticle'
export default {
  name: 'Middlenav',
  components: {
    LogoSearch,
    LeftNav,
    MainNav,
    AdModel,
    LoginTable,
    HotArticle,
    News
  },
  data () {
    return {
      middleMainNav,
      cityFormInfo,
      newsData: []
    }
  },
  created () {
    this.getNewsData()
  },
  mounted () {},
  computed: {
    cityId () {
      return this.$store.state.soukecityId
    }
  },
  watch: {
    cityId (newVal) {
      this.juniorTypeid = cityFormInfo[newVal].juniorTypeid
      this.seniorTypeid = cityFormInfo[newVal].highTypeid
      return newVal
    }
  },
  methods: {
    getNewsData () {
      getArticle('1172', 3, '_WWW').then(response => {
        this.newsData = response
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.mainswiper
  width: 1200px
  height: 524px
  margin: 0 auto
  overflow: hidden
  display: flex
  .mid-part
    float: left
    display: flex
    flex: 1
    flex-direction: column
    .content
      overflow: hidden
      position: relative
      .admodel
        float: left
      .right-part
        display: flex
        height: 472px
        width: 251px
        flex-direction: column
        position: absolute
        right: 2px
</style>



// WEBPACK FOOTER //
// src/pages/middleschool/Middlenav.vue